import creator from "./creator";
import select from "./select";

export default function(name) {
  return select(creator(name).call(document.documentElement));
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/create.js
// module id = 1321
// module chunks = 0